import React, { Component } from "react";
import axios from "axios";

export default class LoginController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true, // Indicates whether the loader should be displayed
    };
  }

  componentDidMount() {
    // Backend API endpoint
    const apiUrl =
      "https://qrcodebackend-458148834331.asia-south1.run.app/qrcode/viewLink";

    // Get the current URL of the project
    const currentURL = window.location.href;

    // Send the current URL to the backend
    axios
      .post(apiUrl, { currentURL }) // Sending current URL in POST request body
      .then((response) => {
        console.log(response);

        // Extract the redirect URL from the result
        const result = response.data.data.result; // Ensure the backend response includes a `result` object
        if (result && result.redirectUrl) {
          const redirectUrl = result.redirectUrl;

          // Redirect to the fetched URL
          window.location.href = redirectUrl;
        } else {
          console.error("Redirect URL not found in the response");
          this.setState({ loading: false }); // Stop loader on error
        }
      })
      .catch((error) => {
        console.error("Error fetching the URL from the backend:", error);
        this.setState({ loading: false }); // Stop loader on error
      });
  }

  render() {
    const { loading } = this.state;

    return (
      <div style={styles.container}>
        {loading && <div style={styles.loader}></div>}
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#ffffff",
  },
  loader: {
    border: "6px solid #f3f3f3", // Light grey background
    borderTop: "6px solid #3498db", // Blue color for active segment
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    animation: "spin 0.5s linear infinite", // Faster rotation with 0.5s duration
  },
  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
};
